// src/keycloak.ts
import Keycloak, { KeycloakInstance } from "keycloak-js";

// Crée une instance Keycloak avec les paramètres de configuration
/*const keycloak: KeycloakInstance = new Keycloak({
  url: "http://localhost:8080",  // Remplacez par l'URL de votre serveur Keycloak
  realm: "ADHSP",                      // Nom de votre realm Keycloak
  clientId: "react-client"             // Nom du client Keycloak
});*/

const REACT_APP_KEYCLOACK_URL=process.env.REACT_APP_KEYCLOACK_URL;
const REACT_APP_KEYCLOACK_REALM=process.env.REACT_APP_KEYCLOACK_REALM;
const REACT_APP_KEYCLOACK_CLIENTID=process.env.REACT_APP_KEYCLOACK_CLIENTID;

const keycloak: KeycloakInstance = new Keycloak({
  url: `${REACT_APP_KEYCLOACK_URL}`,  // Remplacez par l'URL de votre serveur Keycloak
  realm: `${REACT_APP_KEYCLOACK_REALM}`,                      // Nom de votre realm Keycloak
  clientId: `${REACT_APP_KEYCLOACK_CLIENTID}`         // Nom du client Keycloak
});

// Fonction pour initialiser Keycloak et gérer l'authentification
export const initKeycloak = (): Promise<boolean> => {
  return keycloak.init({
    onLoad: "login-required",         // "login-required" pour forcer la connexion ou "check-sso" pour ne pas exiger la connexion à chaque chargement
    pkceMethod: "S256",               // Active PKCE pour plus de sécurité (recommandé)
    silentCheckSsoRedirectUri: window.location.origin + "/silent-check-sso.html", // Optionnel : Pour une vérification SSO sans interrompre l'utilisateur
  });
};

// Fonction pour actualiser le token
// Fonction pour obtenir un token valide et actualisé
export const getValidToken = async (): Promise<string | null> => {
  if (keycloak.token) {
    try {
      const refreshed = await keycloak.updateToken(50); // Met à jour le token si son expiration est dans moins de 5 secondes
      if (refreshed) {
        console.log("Token mis à jour", keycloak.token);
      }
      console.log("cdc"+keycloak.token);
      localStorage.setItem("jwt", keycloak.token || "");
      return keycloak.token;
    } catch (error) {
      console.error("Erreur lors de la mise à jour du token", error);
    }
  }
  return null;
};

// Fonction de connexion manuelle
export const login = (): void => {
  keycloak.login();
};

// Fonction de déconnexion manuelle
export const logout = (): void => {
  keycloak.logout({ redirectUri: window.location.origin });
};

// Exporte l'instance Keycloak pour une utilisation dans toute l'application
export default keycloak;
